import { Field, Int, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class AvailableDownloadCodeDto {
  @Field(t => Int)
  site!: number

  @Field(t => Int)
  count!: number

  /**
   * How many codes the author put up for the store, claimed or not - which stores the campaign offers at all.
   * The reader's store picker narrows on this now that the code lists themselves are kept from it [sc-28919].
   */
  @Field(t => Int)
  total!: number
}
